function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.09375,
  y: 6.03125,
  width: 27.8125,
  height: 19.9375,
  rx: 1.75,
  fill: "url(#paint0_linear_18_21780)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.09375,
  y: 6.03125,
  width: 27.8125,
  height: 19.9375,
  rx: 1.75,
  fill: "url(#paint1_linear_18_21780)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6.03125V25.9688H3.84375C2.87726 25.9688 2.09375 25.1852 2.09375 24.2188V7.78125C2.09375 6.81476 2.87726 6.03125 3.84375 6.03125H16Z",
  fill: "url(#paint2_linear_18_21780)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6.03125V25.9688H3.84375C2.87726 25.9688 2.09375 25.1852 2.09375 24.2188V7.78125C2.09375 6.81476 2.87726 6.03125 3.84375 6.03125H16Z",
  fill: "url(#paint3_radial_18_21780)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6.03125V25.9688H28.1562C29.1227 25.9688 29.9062 25.1852 29.9062 24.2188V7.78125C29.9062 6.81476 29.1227 6.03125 28.1562 6.03125H16Z",
  fill: "url(#paint4_linear_18_21780)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6.03125V25.9688H28.1562C29.1227 25.9688 29.9062 25.1852 29.9062 24.2188V7.78125C29.9062 6.81476 29.1227 6.03125 28.1562 6.03125H16Z",
  fill: "url(#paint5_linear_18_21780)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6.03125V25.9688H28.1562C29.1227 25.9688 29.9062 25.1852 29.9062 24.2188V7.78125C29.9062 6.81476 29.1227 6.03125 28.1562 6.03125H16Z",
  fill: "url(#paint6_linear_18_21780)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6.03125V25.9688H28.1562C29.1227 25.9688 29.9062 25.1852 29.9062 24.2188V7.78125C29.9062 6.81476 29.1227 6.03125 28.1562 6.03125H16Z",
  fill: "url(#paint7_linear_18_21780)"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_18_21780)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.09375 24.2188C2.09375 23.9563 2.22895 23.7123 2.45151 23.5732L15.7799 15.2421C15.9097 15.1609 16.0746 15.161 16.2043 15.2423L29.5771 23.624C29.7819 23.7524 29.9062 23.9771 29.9062 24.2188V24.2188C29.9062 25.1852 29.1227 25.9688 28.1562 25.9688H3.84375C2.87726 25.9688 2.09375 25.1852 2.09375 24.2188V24.2188Z",
  fill: "url(#paint8_linear_18_21780)"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M2.09375 24.2188C2.09375 23.9563 2.22895 23.7123 2.45151 23.5732L15.7799 15.2421C15.9097 15.1609 16.0746 15.161 16.2043 15.2423L29.5771 23.624C29.7819 23.7524 29.9062 23.9771 29.9062 24.2188V24.2188C29.9062 25.1852 29.1227 25.9688 28.1562 25.9688H3.84375C2.87726 25.9688 2.09375 25.1852 2.09375 24.2188V24.2188Z",
  fill: "url(#paint9_linear_18_21780)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M2.09375 24.2188C2.09375 23.9563 2.22895 23.7123 2.45151 23.5732L15.7799 15.2421C15.9097 15.1609 16.0746 15.161 16.2043 15.2423L29.5771 23.624C29.7819 23.7524 29.9062 23.9771 29.9062 24.2188V24.2188C29.9062 25.1852 29.1227 25.9688 28.1562 25.9688H3.84375C2.87726 25.9688 2.09375 25.1852 2.09375 24.2188V24.2188Z",
  fill: "url(#paint10_linear_18_21780)"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_ii_18_21780)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.09375 7.78125C2.09375 8.04371 2.22895 8.28767 2.45151 8.42678L15.7799 16.7579C15.9097 16.8391 16.0746 16.839 16.2043 16.7577L29.5771 8.37596C29.7819 8.24761 29.9062 8.02293 29.9062 7.78125V7.78125C29.9062 6.81476 29.1227 6.03125 28.1562 6.03125H3.84375C2.87726 6.03125 2.09375 6.81476 2.09375 7.78125V7.78125Z",
  fill: "url(#paint11_linear_18_21780)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.09375 7.78125C2.09375 8.04371 2.22895 8.28767 2.45151 8.42678L15.7799 16.7579C15.9097 16.8391 16.0746 16.839 16.2043 16.7577L29.5771 8.37596C29.7819 8.24761 29.9062 8.02293 29.9062 7.78125V7.78125C29.9062 6.81476 29.1227 6.03125 28.1562 6.03125H3.84375C2.87726 6.03125 2.09375 6.81476 2.09375 7.78125V7.78125Z",
  fill: "url(#paint12_linear_18_21780)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.09375 7.78125C2.09375 8.04371 2.22895 8.28767 2.45151 8.42678L15.7799 16.7579C15.9097 16.8391 16.0746 16.839 16.2043 16.7577L29.5771 8.37596C29.7819 8.24761 29.9062 8.02293 29.9062 7.78125V7.78125C29.9062 6.81476 29.1227 6.03125 28.1562 6.03125H3.84375C2.87726 6.03125 2.09375 6.81476 2.09375 7.78125V7.78125Z",
  fill: "url(#paint13_linear_18_21780)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.09375 7.78125C2.09375 8.04371 2.22895 8.28767 2.45151 8.42678L15.7799 16.7579C15.9097 16.8391 16.0746 16.839 16.2043 16.7577L29.5771 8.37596C29.7819 8.24761 29.9062 8.02293 29.9062 7.78125V7.78125C29.9062 6.81476 29.1227 6.03125 28.1562 6.03125H3.84375C2.87726 6.03125 2.09375 6.81476 2.09375 7.78125V7.78125Z",
  fill: "url(#paint14_radial_18_21780)"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_18_21780)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.3289 23.4719C19.1949 23.4719 22.3289 20.3379 22.3289 16.4719C22.3289 12.6059 19.1949 9.47192 15.3289 9.47192C11.4629 9.47192 8.32892 12.6059 8.32892 16.4719C8.32892 20.3379 11.4629 23.4719 15.3289 23.4719Z",
  fill: "#C2A5D0"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_iii_18_21780)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.9531 23C19.8191 23 22.9531 19.866 22.9531 16C22.9531 12.134 19.8191 9 15.9531 9C12.0871 9 8.95312 12.134 8.95312 16C8.95312 19.866 12.0871 23 15.9531 23Z",
  fill: "url(#paint15_linear_18_21780)"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_dii_18_21780)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.9531 11.5001C14.7431 11.4801 13.5931 11.9401 12.7331 12.8001C11.8631 13.6501 11.3931 14.7901 11.3931 16.0001C11.3931 18.4801 13.4131 20.5001 15.8931 20.5001C16.1531 20.5001 16.3631 20.2901 16.3631 20.0301C16.3631 19.7701 16.1531 19.5601 15.8931 19.5601C13.9331 19.5601 12.3331 17.9601 12.3331 16.0001C12.3331 15.0401 12.7131 14.1401 13.3931 13.4701C14.0731 12.8001 14.9831 12.4401 15.9431 12.4401C17.8731 12.4701 19.4531 14.0901 19.4531 16.0601V16.8701C19.4531 17.2401 19.1531 17.5401 18.7831 17.5401C18.4131 17.5401 18.1131 17.2401 18.1131 16.8701V13.7901C18.1131 13.5301 17.9031 13.3201 17.6431 13.3201C17.3831 13.3201 17.1531 13.5301 17.1531 13.7901V13.8801C16.7131 13.5301 16.1631 13.3101 15.5531 13.3101C14.1531 13.3101 13.0131 14.4501 13.0131 15.8501C13.0131 17.2501 14.1531 18.3901 15.5531 18.3901C16.2531 18.3901 16.8931 18.1001 17.3531 17.6401C17.6331 18.1401 18.1631 18.4801 18.7731 18.4801C19.6631 18.4801 20.3931 17.7501 20.3931 16.8601V16.0501C20.3931 13.5801 18.4031 11.5301 15.9531 11.5001ZM15.5631 17.4601C14.6831 17.4601 13.9631 16.7401 13.9631 15.8601C13.9631 14.9801 14.6831 14.2601 15.5631 14.2601C16.4431 14.2601 17.1631 14.9801 17.1631 15.8601C17.1631 16.7401 16.4431 17.4601 15.5631 17.4601Z",
  fill: "#E6E0ED"
}));

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_18_21780",
  x: 2.09375,
  y: 14.4312,
  width: 27.8125,
  height: 11.5376,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.75
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.75
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.819608 0 0 0 0 0.654902 0 0 0 0 0.933333 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_21780"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_ii_18_21780",
  x: 2.09375,
  y: 5.88125,
  width: 27.8125,
  height: 11.1876,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.15
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.225
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.827451 0 0 0 0 0.686275 0 0 0 0 0.913725 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_21780"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.870588 0 0 0 0 0.858824 0 0 0 0 0.854902 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_21780",
  result: "effect2_innerShadow_18_21780"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_18_21780",
  x: 6.82892,
  y: 7.97192,
  width: 17,
  height: 17,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.75,
  result: "effect1_foregroundBlur_18_21780"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_iii_18_21780",
  x: 8.80312,
  y: 8.75,
  width: 14.4,
  height: 14.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.192157 0 0 0 0 0.376471 0 0 0 0 0.721569 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_21780"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.32549 0 0 0 0 0.341176 0 0 0 0 0.819608 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_21780",
  result: "effect2_innerShadow_18_21780"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.15,
  dy: 0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.317647 0 0 0 0 0.596078 0 0 0 0 0.882353 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_18_21780",
  result: "effect3_innerShadow_18_21780"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_dii_18_21780",
  x: 10.9931,
  y: 11.2495,
  width: 9.5,
  height: 9.65073,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.15,
  dy: 0.15
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.152941 0 0 0 0 0.341176 0 0 0 0 0.768627 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_18_21780"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_18_21780",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.803922 0 0 0 0 0.713726 0 0 0 0 0.921569 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_18_21780"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.15,
  dy: 0.15
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.917647 0 0 0 0 0.890196 0 0 0 0 0.952941 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_18_21780",
  result: "effect3_innerShadow_18_21780"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_21780",
  x1: 4.09375,
  y1: 17.1562,
  x2: 29.9063,
  y2: 16.9688,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DFD0E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE5F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18_21780",
  x1: 2.09375,
  y1: 17.095,
  x2: 5.13196,
  y2: 17.095,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D6BABD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DCC9DD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_18_21780",
  x1: 10.8374,
  y1: 18.9732,
  x2: 10.0755,
  y2: 17.786,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.113759,
  stopColor: "#DAC3DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAC3DF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_18_21780",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.1236 13.3806) rotate(123.69) scale(2.72523 19.1395)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.342267,
  stopColor: "#C8A6D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D1BBDD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_18_21780",
  x1: 21.0937,
  y1: 19.2813,
  x2: 21.9245,
  y2: 17.786,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.113759,
  stopColor: "#F6EFFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3EAFD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_18_21780",
  x1: 20.1563,
  y1: 13.9375,
  x2: 21.2187,
  y2: 15.375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3CDF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9D9F8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_18_21780",
  x1: 30.0937,
  y1: 19.5625,
  x2: 26.375,
  y2: 19.5625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7F3FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F0E9F8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_18_21780",
  x1: 30.0938,
  y1: 19.5625,
  x2: 28.8684,
  y2: 19.5625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.199295,
  stopColor: "#EBE9ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBE9ED",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_18_21780",
  x1: 16,
  y1: 27.7187,
  x2: 16,
  y2: 16.9063,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DDC5F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6DAF1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_18_21780",
  x1: 7.48609,
  y1: 20.1064,
  x2: 7.94242,
  y2: 20.7909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0734082,
  stopColor: "#DDC2C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DFCDDA",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_18_21780",
  x1: 22.5808,
  y1: 19.1586,
  x2: 22.294,
  y2: 19.606,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.139796,
  stopColor: "#F8F3FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1EAF9",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_18_21780",
  x1: 16,
  y1: 6.03125,
  x2: 16,
  y2: 16.8187,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9E4E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7DCF0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_18_21780",
  x1: 9.8097,
  y1: 12.8779,
  x2: 13.4243,
  y2: 6.39289,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E1D5E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E1D5E7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_18_21780",
  x1: 2.09375,
  y1: 7.66864,
  x2: 5.02564,
  y2: 7.66864,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E1C1BC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E1C1BC",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9D1CD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_18_21780",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.4575 10.1138) rotate(-138.233) scale(6.12906 27.1579)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBF9FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F0ECF1",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_18_21780",
  x1: 22.4375,
  y1: 14.2812,
  x2: 10.6875,
  y2: 18.5938,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#347BD7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3477CB"
})));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5add4530.svg";
export { ForwardRef as ReactComponent };